// 🌿 API Craft Back Office - Foreign Key Options Hook
import { useState, useEffect } from 'react';
import { crudApi } from '../services/api';
import { DynamicRecord } from '../types';

export const useForeignKeyOptions = (referenceModel: string | undefined) => {
  const [options, setOptions] = useState<DynamicRecord[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!referenceModel) {
      setOptions([]);
      return;
    }

    const fetchOptions = async () => {
      setIsLoading(true);
      setError(null);
      try {
        console.log(`🔄 Fetching options for FK reference: ${referenceModel}`);
        const response = await crudApi.getRecords(referenceModel, 1, 100); // Get up to 100 records
        setOptions(response.data || []);
        console.log(`✅ Loaded ${response.data?.length || 0} options for ${referenceModel}`);
      } catch (err: any) {
        console.error(`🚨 Error loading FK options for ${referenceModel}:`, err);
        const errorMessage = err.response?.data?.detail || err.message || 'Failed to load options';
        setError(errorMessage);
        setOptions([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchOptions();
  }, [referenceModel]);

  return {
    options,
    isLoading,
    error
  };
};
